export default __webpack_public_path__ + "static/media/svv-logo-full_1889x989.89d5d0ab.png";